import { useGLTF, useTexture } from "@react-three/drei";
import { useState } from "react";

export const TexturePreloader = ({ src }: { src: string }) => {
  useTexture(src);
  return null;
};

export const GLTFPreloader = ({ src }: { src: string }) => {
  useGLTF(src);
  return null;
};

export const LoadedNotifier = ({ onLoaded }: { onLoaded: () => void }) => {
  // This will render after Suspense resolves
  useState(() => {
    requestAnimationFrame(() => onLoaded());
  });
  return null;
};

// Easing function for smooth animation
export function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3;
}

// Calculate responsive camera Z position based on viewport
export function getResponsiveCameraZ(width: number, height: number): number {
  const aspectRatio = width / height;
  const baseZ = 3;

  if (aspectRatio < 0.8) {
    return baseZ + 2.5;
  }
  if (aspectRatio < 1.2) {
    return baseZ + 1.2;
  }
  return baseZ;
}
